import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom"
import {Col, Dropdown, DropdownButton, FormControl, InputGroup, Row} from "react-bootstrap"
import {MenuDots, SearchIcon} from "../../components/SvgIcons"
import {toast} from "react-toastify";
import DataTable from 'react-data-table-component';
import BarLoader from "react-spinners/BarLoader";
import {customStyles} from "../../utils/constants";
import moment from "moment";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import DataTableExtensions from "react-data-table-component-extensions";
import {EmptyState} from "../../components/EmptyState";
import {DeletePost, GetPosts} from "../../services/posts.service";
import swal from "sweetalert"

function Post() {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState();
    const [rows, setRows] = useState();
    const [keyword, setKeyword] = useState('');

    const getPosts = async () => {
        setLoading(true)
        await GetPosts(keyword, page, perPage).then((result) => {
            if (result.status) {
                if (result.data.data) {
                    const rowData = [];

                    setTotalRows(result.data.pagination.total);
                    let counter = 1; // Initialize the counter to start from 1
                    result.data.data.map((dt, index) => {
                        rowData.push({
                            sno: counter++,
                            _id: dt._id || '-',
                            title: dt.title || '-',
                            created_at: moment(dt.created_at).fromNow(),
                        });

                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                setRows([]);
                return toast.error(result.data.message);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        })
    }

    useEffect(async () => {
        await getPosts();
    }, [keyword, page, perPage])

    const onDetail = (data) => {
        history.push('/videos/detail/' + data._id, {
            data: data
        });
    }

    const onDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this video?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willShip) => {
            //Delete  API
            if (willShip) {
                await DeletePost(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getPosts();
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error?.response?.status === 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {
                        return toast.error(error.message);
                    }
                })
            }
        });
    }

    const userActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots />}>
                <Dropdown.Item as="button" onClick={() => onDetail(data)}>Detail</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onDelete(data._id)}>Delete</Dropdown.Item>
            </DropdownButton>
        )
    }

    const caseInsensitiveNameSort = (rowA, rowB) => {

        const a = rowA.title.toLowerCase();
        const b = rowB.title.toLowerCase();
        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    const columns = [
        {
            id: 'sno',
            name: 'ID',
            sortable: true,
            center: true,
            selector: rowData => rowData.sno,
            cellExport: rowData => rowData.sno,
        },
        {
            id: 'name',
            name: 'Title',
            center: true,
            sortable: true,
            sortField: 'title',
            sortFunction: caseInsensitiveNameSort,
            selector: rowData => rowData.title,
            cellExport: rowData => rowData.title,
        },
        {
            id: 'created_at',
            name: 'Created At',
            grow: false,
            center: true,
            selector: rowData => rowData.created_at,
            cellExport: rowData => rowData.created_at
        },
        {
            id: 'action',
            name: 'Action',
            center: true,
            cell: rowData => userActions(rowData),
            export: false
        },
    ];

    return (
        <div className={"usersPage"}>
            <h1 className="page-heading">Videos</h1>
            <hr />
            <div className={"customOrderFilters"}>
                <Row>
                    <Col xs={4} sm={4} md={4}>
                        {/*{rows && rows.length > 0 ? (*/}
                        <InputGroup className="mb-3 search-group">
                            <InputGroup.Text id="basic-addon1"><SearchIcon /></InputGroup.Text>
                            <FormControl
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="Search"
                                maxLength={"255"}
                                onChange={(e) => {
                                    (e.target.value.length > 2) ? setKeyword(e.target.value) : setKeyword(null)
                                }}
                            />
                        </InputGroup>
                        {/*) : ('')}*/}
                    </Col>

                    <Col xs={2} sm={2} >
                        {/*<Link to={"/advertisements/create-advertisement"}>*/}
                        {/*    <Button className={"btn btn-green-theme h40 w-100"}>*/}
                        {/*        <AddIconOutline /> Add New*/}
                        {/*    </Button>*/}

                        {/*</Link>*/}
                    </Col>

                </Row>
            </div>
            <div className="theme-dataGrid products-dataGrid" style={{"cursor":"pointer"}}>
                {rows && rows.length == 0 ? (
                    <EmptyState/> // Render the EmptyState component when there are no records
                ): (
                    <DataTableExtensions
                        columns={columns}
                        data={rows}
                        filter={false}
                        print={false}
                        exportHeaders
                        fileName='Packages'
                    >
                        <DataTable
                            pagination
                            columns={columns}
                            data={rows}
                            persistTableHead
                            progressPending={loading}
                            customStyles={customStyles}
                            selectableRows={false}
                            striped
                            highlightOnHover

                            paginationServer
                            paginationTotalRows={totalRows}

                            onChangePage={(page) => {
                                setPage(page);
                            }}
                            onChangeRowsPerPage={(currentRowsPerPage) => {
                                setPerPage(currentRowsPerPage)
                            }}
                            progressComponent={<BarLoader color={'#f39633'} loading={loading} css={'marginTop: 10px'}
                                                          height={'4'} width={'100%'} />}
                        />
                    </DataTableExtensions>

                )}
            </div>
        </div>
    )
}

export default Post
